import React from 'react';
import 'react-quill/dist/quill.snow.css';

const Description = ({ desc }) => {
  if (!desc) {
    return (
      <div className="mt-2 p-6 bg-gray-90">
        <h2 className="text-xl font-stack-text 900 mb-3">Descripción General</h2>
        <p className="text-gray-500">Sin descripción disponible</p>
      </div>
    );
  }

  return (
    <div className="mt-2 p-6 bg-gray-90">
      <h2 className="text-xl font-stack-text 900 mb-3">Descripción General</h2>
      <div
        className="ql-editor text-gray-700"
        style={{ padding: 0, overflow: 'visible' }}
        dangerouslySetInnerHTML={{ __html: desc }}
      />
    </div>
  );
};

export default Description;
